


export const GLOBAL_MS_SALES_BTN_FILTERS = [
  { id: "tier_one_btn", name: "Sales & Inventory", navigateTo: "/global_ms_sales/tier_one" },
  { id: "tier_two_btn", name: "Marketing & Leads Generation", navigateTo: "/global_ms_sales/tier_two" },
  { id: "tier_three_btn", name: "Marketing Performance", navigateTo: "/global_ms_sales/tier_three" },
];

export const LookStudioEmbeddedLinks = {
  tier_one: "https://lookerstudio.google.com/embed/reporting/502bbc28-1c7f-4013-b706-a62e7a00a9f7/page/p_zzxdazt0ud?hl=en",
  tier_two: "https://lookerstudio.google.com/embed/reporting/76a79865-133b-4c25-94bd-d3be1efed718/page/p_nm84vwbzwd?hl=en",
  tier_three: "https://lookerstudio.google.com/embed/reporting/750b3d56-f17c-4cd8-89ad-f96111e5da9c/page/p_k7yftw3oyd?hl=en",
  trim_mix_report: "https://datastudio.google.com/embed/reporting/f4d97ac3-e8e6-45a9-a142-8110d4d3ca51/page/ky3wF?hl=en",
  IgniteNissanPdf: `${window.location.origin}/documents/Nissan_Account.pdf`,
  IgniteNissanHandbookPdf: "https://nissangroup.sharepoint.com/teams/JAO_NML_07_024678_CEDARCollaboration/_layouts/15/Doc.aspx?sourcedoc=%7bf3986cfb-1159-466d-b5b7-887cfdf45c29%7d&amp;action=embedview&amp;wdAr=1.7777777777777777",
  domo_url: "https://mail-nissan-co-jp.domo.com/embed/pages/private/oZo13",
  domoscreen_url: "https://domo-nml.nissan-cedar.com/embed/pages/private/oZo13",
  submit_domo_url: "https://forms.office.com/Pages/ResponsePage.aspx?id=rqAXRpIagkSoM3utU1sykuxiUAtyYE1JrwDwPoJLL8lUOTJIQkgzSFM0NlAwOU5KQlBLNVQ4S1U1MC4u&embed=true%22%20frameborder=%220%22%20marginwidth=%220%22%20marginheight=%220%22%20style=%22border:%20none;%20max-width:100%;%20max-height:100vh"
};